import EventBus from "eventing-bus"
import {
  constants,
  getCurrSection,
  getTruckModelsArr,
  getWheelModelsArr,
  getCurrTruck,
  setCurrTruck,
  getCurrWheel,
  setCurrWheel,
  setCurrSection,
} from "../model"
import gsap from "gsap"

let viewEl = null,
  thumbsWrapperEl = null,
  heroThumbsWrapperEl = null,
  dataArr = [],
  imagesArr = [],
  isSection1LoadedFirstTime = false,
  isSection2LoadedFirstTime = false,
  isFirstTimeThroughThisIteration = null

/**
 * Event handlers
 */
const handleSectionchanged = () => {
  isFirstTimeThroughThisIteration = true
  viewEl = null
  thumbsWrapperEl = null
  heroThumbsWrapperEl = null
  dataArr = []
  imagesArr = []

  // Trucks
  if (getCurrSection() === 1) {
    viewEl = document.querySelector("#trucks-nav-view")
    thumbsWrapperEl = viewEl.querySelector(".thumbs-wrapper")
    heroThumbsWrapperEl = viewEl.querySelector(".hero-thumbs-test ")
    dataArr = getTruckModelsArr()
    if (!isSection1LoadedFirstTime) loadImages()
    isSection1LoadedFirstTime = true
    setTimeout(() => {
      viewEl.classList.add("show")
      handleTruckChanged()
    }, 2000)
  } else {
    destroyScene()
  }

  // Wheels
  if (getCurrSection() === 2) {
    viewEl = document.querySelector("#wheels-nav-view")
    thumbsWrapperEl = viewEl.querySelector(".thumbs-wrapper")
    heroThumbsWrapperEl = viewEl.querySelector(".hero-thumbs-test ")
    dataArr = getWheelModelsArr()
    if (!isSection2LoadedFirstTime) loadImages()
    isSection2LoadedFirstTime = true
    setTimeout(() => {
      viewEl.classList.add("show")
      handleTruckChanged()
    }, 2000)
  } else {
    destroyScene()
  }
}

const handleTruckChanged = () => {
  centerCurrent()
}

EventBus.on(constants.TRUCK_CHANGED, handleTruckChanged)
EventBus.on(constants.WHEEL_CHANGED, handleTruckChanged)
EventBus.on(constants.SECTION_CHANGED, handleSectionchanged)

const centerCurrent = () => {
  let numThumbs = dataArr.length,
    thumbsItems = thumbsWrapperEl.querySelectorAll(".item"),
    currThumbItemEl = thumbsItems[getCurrProduct()],
    itemWidth = currThumbItemEl.getBoundingClientRect().width,
    thumbsScreenCenter = window.innerWidth * 0.5 - itemWidth * 0.5

  // Thumbs
  for (let i = 0; i < numThumbs; i++) {
    const item = thumbsItems[i]
    const posFromCurr = i - getCurrProduct()
    if (isFirstTimeThroughThisIteration) {
      gsap.set(item, { alpha: 0, x: thumbsScreenCenter })
      gsap.to(item, { duration: 1.2, alpha: 1, x: thumbsScreenCenter + posFromCurr * itemWidth, ease: "power3.out" })
    } else {
      gsap.to(item, {
        duration: 0.7,
        x: thumbsScreenCenter + posFromCurr * itemWidth,
        delay: i * 0.03,
        ease: "power3.inOut",
      })
    }
  }

  // Hero thumbs
  const heroThumbsItems = heroThumbsWrapperEl.querySelectorAll(".window .item")
  const currHeroThumbItemEl = heroThumbsItems[getCurrProduct()]
  const heroThumIitemWidth = currHeroThumbItemEl.getBoundingClientRect().width

  thumbsScreenCenter = 0

  for (let i = 0; i < numThumbs; i++) {
    const items = [heroThumbsItems[i]],
      posFromCurr = i - getCurrProduct()
    if (isFirstTimeThroughThisIteration) {
      gsap.set(items, { alpha: 0, x: thumbsScreenCenter })
      gsap.to(items, { duration: 1.2, alpha: 1, x: thumbsScreenCenter + posFromCurr * heroThumIitemWidth, ease: "power3.out" })
    } else {
      gsap.to(items, {
        duration: 0.7,
        x: thumbsScreenCenter + posFromCurr * heroThumIitemWidth,
        delay: i * 0.03,
        ease: "power3.inOut",
      })
    }
  }
  isFirstTimeThroughThisIteration = false
}

const buildThumbs = () => {
  dataArr.map((d, i) => {
    const itemEl = document.createElement("div"),
      imgEl = document.createElement("img")
    thumbsWrapperEl.appendChild(itemEl)
    itemEl.className = "item"
    imgEl.src = imagesArr[i]
    itemEl.appendChild(imgEl)
    itemEl.addEventListener("click", () => {
      if (getCurrProduct() !== i) {
        if (getCurrSection() === 1) setCurrTruck(i)
        else setCurrWheel(i)
      } else {
        if (getCurrSection() === 1) setCurrSection(2)
        else setCurrSection(3)
      }
    })
  })
  dataArr.map((d, i) => {
    const itemEl = document.createElement("div"),
      imgEl = document.createElement("img"),
      windowEl = viewEl.querySelector(".window")

    windowEl.appendChild(itemEl)
    itemEl.className = "item"
    imgEl.src = imagesArr[i]
    itemEl.appendChild(imgEl)
  })
}

const loadImages = () => {
  dataArr.map((d, i) => {
    const imgPath = dataArr[i].thumbSrc
    const img = require("../assets/images/" + imgPath)
    imagesArr[i] = img
  })
  buildThumbs()
}

const getCurrProduct = () => {
  return getCurrSection() === 1 ? getCurrTruck() : getCurrWheel()
}

const destroyScene = () => {
  if (document.querySelector("#trucks-nav-view .item")) {
    document.querySelector("#trucks-nav-view").classList.remove("show")
  }
  if (document.querySelector("#wheels-nav-view .item")) {
    document.querySelector("#wheels-nav-view").classList.remove("show")
  }
}
